<template>
  <div :class="classes">
    <slot></slot>
    <span v-if="error" class="error-text">{{ message || error.message }}</span>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {Hash} from "../../interfaces/hashInterfaces";
  import {INavigableValidatableModel} from "../../interfaces/navigableValidationInterfaces";
  import ValidationError from "../../models/validationError";

  export default Vue.extend({
    props: {
      model: {
        type: Object as () => INavigableValidatableModel<any>,
        required: true
      },
      fieldName: {
        type: String,
        required: true
      },
      message: {
        type: String,
        required: false
      }
    },
    computed: {
      error(): ValidationError | null {
        return this.model.validation.errors.find(it => it.field === this.fieldName);
      },
      classes(): Hash<boolean> {
        return {
          'field_with_errors': !!this.error,
        };
      },
    }
  });
</script>